import { ETransactionReasons, ETransactionTypes } from 'entities/Transaction';
import { i18n } from 'i18n';

export const TRANSACTION_REASONS = () => ({
	[ETransactionReasons.ACTION]: i18n.t('Оплата за действие'),
	[ETransactionReasons.WITHDRAWAL]: i18n.t('Перевод средств на Affilead Wallet'),
	[ETransactionReasons.BONUS]: i18n.t('Бонус'),
	[ETransactionReasons.ADJUSTMENT]: i18n.t('Корректировка баланса'),
});

export const TRANSACTION_TYPES = () => ({
	[ETransactionTypes.REPLENISHMENT]: i18n.t('Пополнение'),
	[ETransactionTypes.DEDUCTION]: i18n.t('Списание'),
});
